/**
 * Linked Excel Editor Agent - Suggestions Section
 * 
 * Section 3: Workflow guidelines and best practices
 * 
 * Provides workflow guidance and agent delegation patterns.
 * 
 * Keywords AI Key: LINKED_EXCEL_SUGGESTIONS
 */

import { PromptSectionBase } from '../../base/systemPrompt/PromptSectionBase';
import { LINKED_EXCEL_PROMPT_KEYS } from './variables';

class LinkedExcelEditorSuggestionsSection extends PromptSectionBase {
    protected readonly keywordsKey = LINKED_EXCEL_PROMPT_KEYS.suggestions;
    protected readonly fallbackContent = `## Best Practices

### Workflow
1. **Read first** - Always understand current state before editing
2. **Use direct tools deliberately** - Pick editContent/editFormat/editChart/editStructure intentionally
3. **Provide clear descriptions** - Natural language task intent plus precise ranges/IDs when available
4. **Batch related changes** - Group similar operations together

### Tool Responsibilities
- **editContent**: For formulas, values, and number formats
- **editFormat**: For colors, borders, fonts, and conditional formatting
- **editChart**: For creating, modifying, or deleting charts (XML-first)
- **editStructure**: For row/column/sheet structural changes

### Common Patterns
- Check sheet names with readExcel "sheets" first
- Use readExcel "content" to verify cell addresses
- For chart edits, use readExcel.readCharts before and after editChart to verify deltas`;
}

const suggestionsSection = new LinkedExcelEditorSuggestionsSection();

/**
 * Get the suggestions section.
 * Uses Keywords AI if available, otherwise falls back to code.
 */
export function getSuggestionsSection(): string {
    return suggestionsSection.getContent();
}

/**
 * Export constant for backwards compatibility
 */
export const LINKED_EXCEL_SUGGESTIONS = suggestionsSection.getFallbackContent();
